import { REWARD_RULE } from "@cede/types";
import { formatBalance } from "@cede/utils";
import { getHoldRewardRule } from "./holdCampaignFormatters";
import {
  HOLD_REWARD_RULE_BADGES,
  getHoldRewardRuleDescriptions,
  HOLD_CAMPAIGN_IMPORTANT_NOTES,
} from "@/constants/hold";
import { HoldCampaignWithStatus, RewardModelDescription } from "@/types/holdCampaigns";

/**
 * Get reward model description based on campaign reward rule
 */
export const getRewardModelDescription = (campaign: HoldCampaignWithStatus): RewardModelDescription => {
  const rewardRule = getHoldRewardRule(campaign);
  const badge = HOLD_REWARD_RULE_BADGES[rewardRule];
  const descriptions = getHoldRewardRuleDescriptions(
    rewardRule,
    campaign.epochDuration || 24,
    campaign.buyInAmountTarget == null ? null : `${formatBalance(campaign.buyInAmountTarget)} ${campaign.tokenSymbol}`,
  );

  return {
    badge: badge.text,
    badgeClass: badge.className,
    descriptions,
  };
};

/**
 * Get important notes for a campaign based on reward rule
 */
export const getCampaignImportantNotes = (rewardRule: REWARD_RULE): string[] => {
  const commonNotes = HOLD_CAMPAIGN_IMPORTANT_NOTES.COMMON;
  const ruleSpecificNotes = HOLD_CAMPAIGN_IMPORTANT_NOTES[rewardRule] || [];

  return [...commonNotes, ...ruleSpecificNotes];
};

/**
 * Check if campaign has fixed spots
 */
export const hasFixedSpots = (campaign: HoldCampaignWithStatus): boolean => {
  return campaign.rewardRule === REWARD_RULE.FIXED_SPOT && !!campaign.numberOfSpots;
};

/**
 * Get campaign reward model label
 */
export const getRewardModelLabel = (rewardRule: REWARD_RULE): string => {
  const badge = HOLD_REWARD_RULE_BADGES[rewardRule];
  return badge.text;
};
